import { animated } from 'react-spring'
import { Text } from '@mote/ui'
import { mediaBreakpointUp } from '@mote/ui/theme/core/breakpoints'
import styled from '@xstyled/styled-components'
import { CommonStyledScrubberWrapper } from './Common.styles'

export const AnimatedWrapper = animated(styled.div({}))

export const StyledIdleContentWrapper = animated(
  styled.div({
    position: 'absolute',
    left: 0,
    right: 0,
    display: 'grid',
    placeItems: 'center',
    gridTemplateRows: '1fr auto',
    minHeight: '100%'
  })
)

export const StyledRecordingContentWrapper = styled(StyledIdleContentWrapper)({
  gridTemplateRows: '1fr auto'
})

export const StyledThinkingContentWrapper = styled(StyledIdleContentWrapper)({
  position: 'relative'
})

export const StyledLanguagePickerWrapper = styled.div<{ isAnonymous: boolean }>(
  {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 12
  },
  props =>
    props.isAnonymous
      ? {
          paddingBottom: 0,
          [mediaBreakpointUp('md')]: {
            paddingBottom: 64
          }
        }
      : {
          paddingBottom: 64
        }
)

export const StyledClickToRecordText = styled(Text).attrs({
  tag: 'span',
  fontSize: 'xl',
  fontWeight: 'bold',
  lineHeight: 'xl'
})({})

export const StyledPausedText = styled(Text).attrs({
  tag: 'span',
  fontSize: 'xl',
  fontWeight: 'normal',
  lineHeight: 'xl',
  color: 'grey.d2'
})({})

export const StyledScrubberWrapper = styled(CommonStyledScrubberWrapper)({
  minWidth: 0,
  marginBottom: 16
})

export const StyledMainContentWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 100,
  gap: 32,
  [mediaBreakpointUp('md')]: {
    gap: 40
  }
})

export const StyledRecordingMainContentWrapper = styled(
  StyledMainContentWrapper
)({
  justifyContent: 'flex-start',
  minHeight: 216,
  [mediaBreakpointUp('md')]: {
    minHeight: 232
  }
})

export const StyledCTAContentWrapper = styled(StyledMainContentWrapper)({
  minHeight: 164,
  marginBottom: 0,
  justifyContent: 'flex-end'
})

export const StyledRecorderButtonsWrapper = styled.div({
  paddingBottom: 24
})

export const StyledRecorderControlsWrapper = animated(
  styled.div({
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  })
)

export const AnimatedStyledMainContentWrapper = animated(
  StyledMainContentWrapper
)

export const StyledFeaturesWrapper = styled.div({
  display: 'block',
  marginTop: 72,
  width: '100%',
  maxWidth: '100%',
  paddingBottom: 32,
  [mediaBreakpointUp('md')]: {
    marginTop: 24,
    paddingBottom: 0,
    maxWidth: 330,
    display: 'none'
  }
})

export const AnimatedFeaturesWrapper = animated(
  styled(StyledFeaturesWrapper)({
    position: 'absolute',
    display: 'none',
    [mediaBreakpointUp('md')]: {
      display: 'block'
    }
  })
)
